<nav>
    <div class="logo">
        <!-- <img src="assets/images/lot_technologies_logo.png" alt="LOT Technologies logo" > -->
        <a href="/">LOT Technologies</a>
    </div>
    <div class="openMenu" (click)="m_menuOpen()"><i class="fa fa-bars"></i></div>
    <div class="mainMenuWrap">
        <ul class="mainMenu" onclick="m_closeMenu()">
            <li><a href="#aboutus">Technologies</a></li>
            <li><a href="#products">Products</a></li>
            <li><a href="#itservice">AI & IT solutions</a></li>
            <li><a href="#contactDetails">Contact</a></li>
        </ul>
        <div class="closeMenu" (click)="m_closeMenu()"><i class="fa fa-times"></i></div>
    </div>
</nav>